import dayjs from "dayjs";

const SPECIES_VOUCHER_TYPES = new Set(["PRODUCTO", "CATEGORIA"]);

const isClosedOrder = (status) => String(status || "").trim().toUpperCase() === "CERRADO";

export const buildVoucherUsageMetrics = (rows = []) => {
	const beneficiaryKeys = new Set();
	let consumedUnits = 0;
	let consumedAmount = 0;
	let speciesMonetaryTotal = 0;
	let latestUsage = null;

	rows.forEach((item) => {
		if (item?.tipoVoucher === "MONTO") {
			consumedAmount += Number(item.cantidadUtilizada || 0);
		}

		if (SPECIES_VOUCHER_TYPES.has(item?.tipoVoucher)) {
			consumedUnits += Number(item.cantidadUtilizada || 0);

			if (isClosedOrder(item.estadoPedido)) {
				speciesMonetaryTotal += Number(item.montoCubiertoVoucher || 0);
			}
		}

		const beneficiaryKey = item?.cliente?.id
			|| item?.cliente?.dni
			|| `${item?.cliente?.apellido || ""}-${item?.cliente?.nombre || ""}`;
		if (beneficiaryKey) beneficiaryKeys.add(String(beneficiaryKey));

		const usageDate = dayjs(item?.creado || item?.fechaPedido);
		if (usageDate.isValid() && (!latestUsage || usageDate.isAfter(latestUsage))) {
			latestUsage = usageDate;
		}
	});

	return {
		consumedUnits,
		consumedAmount,
		speciesMonetaryTotal: Number(speciesMonetaryTotal.toFixed(2)),
		beneficiaries: beneficiaryKeys.size,
		latestUsage,
	};
};
